import React from 'react';
import RoundedRectangleButton from 'src/components/RoundedRectangleButton';
import { Box, HyperLink } from 'src/lib/StyledComponents';

class ContactUs extends React.Component {
	email = 'mailto:hello@fundraisewisely.com';

	openEmail = () => {
		window.open(this.email, '_blank');
	};

	render() {
		return (
			<Box marginTop="20px">
				{this.props.errorMsg ? <p>{this.props.errorMsg}</p> : null}
				Please{' '}
				<HyperLink href={this.email} target="_blank">
					send us an email
				</HyperLink>{' '}
				or click the Intercom button on the bottom right to proceed.
				<RoundedRectangleButton
					fontWeight="700"
					textAlign="center"
					maxHeight="40px"
					fontSize="16px"
					marginTop="53px"
					marginBottom="10px"
					onClick={this.openEmail}
				>
					Contact us
				</RoundedRectangleButton>
			</Box>
		);
	}
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/ContactUs/index.js